/** Where to go after sign-in: only a path on this site, taken from `next` (a path or a same-origin URL). */
export function safeNext(raw: string | null, origin: string): string {
  if (!raw) return '/';
  try {
    const u = new URL(raw, origin);
    if (u.origin !== origin || u.pathname.startsWith('/auth/')) return '/';
    return `${u.pathname}${u.search}${u.hash}` || '/';
  } catch { return '/'; }
}
